var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags-wrap",class:{
      'tags--has-tags': _vm.hasTags
    }},[(_vm.hasTags)?_c('af-h3',[_vm._v("Dina val")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tags"},[_vm._l((_vm.tags),function(tag){return _c('search-tag',{key:(tag.type) + "-" + (tag.path) + (tag.value !== undefined ? ("-" + (tag.value)): ''),attrs:{"tag":tag}})}),_vm._v(" "),(_vm.hasTags)?_c('button',{staticClass:"tags__reset",on:{"click":_vm.resetQuery}},[_c('icon',{staticClass:"tags__reset-icon",attrs:{"fill":"white","size":16,"type":"undo"}}),_vm._v("\n      Rensa alla val\n    ")],1):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-530d321d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Search/SearchTags.vue
// module id = 692
// module chunks = 1